import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { IdentificationSection, ShiftSection, ProductPresentationSection, ModulesSection, GuaranteeSection, FinalCTA, CreatorSection, InvestmentValueSection } from './components/ContentSections';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQAccordion } from './components/FAQAccordion';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel Type Definition
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45680841261217:1';
  // Initialize Meta Pixel - Full implementation matching Facebook's official code
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;
    // Initialize fbq function if not exists
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    // Load the Facebook Pixel script
    const scriptId = 'facebook-pixel-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    // Initialize and track PageView
    window.fbq('init', '26355704687375920');
    window.fbq('track', 'PageView');
    // Add noscript fallback image
    const noscriptId = 'facebook-pixel-noscript';
    if (!document.getElementById(noscriptId)) {
      const noscript = document.createElement('noscript');
      noscript.id = noscriptId;
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=26355704687375920&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  const scrollToPrice = () => {
    const element = document.getElementById('pricing-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-red-100" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      {/* 1. Hero Section */}
      <Hero onScrollToPrice={scrollToPrice} data-id="element-2" />

      {/* 2. Identification Section (Pain) */}
      <IdentificationSection onScrollToPrice={scrollToPrice} data-id="element-3" />

      {/* 3. Shift/Revelation Section */}
      <ShiftSection data-id="element-4" />

      {/* 4. Product Presentation */}
      <ProductPresentationSection onScrollToPrice={scrollToPrice} data-id="element-5" />

      {/* 5. What's Included (Modules) */}
      <ModulesSection data-id="element-6" />

      {/* Bonuses */}
      <Bonuses onScrollToPrice={scrollToPrice} data-id="element-7" />

      {/* 6. Social Proof */}
      <Testimonials data-id="element-8" />

      {/* 6.5 Creator */}
      <CreatorSection data-id="element-9" />

      {/* 6.7 Investment Value */}
      <InvestmentValueSection onScrollToPrice={scrollToPrice} data-id="element-10" />

      {/* 7. Offer & Price */}
      <Pricing checkoutUrl={CHECKOUT_URL} data-id="element-11" />

      {/* 8. Guarantee */}
      <GuaranteeSection data-id="element-12" />

      {/* FAQ */}
      <FAQAccordion data-id="element-13" />

      {/* 9. Final CTA */}
      <FinalCTA checkoutUrl={CHECKOUT_URL} data-id="element-14" />

      {/* Footer */}
      <footer className="bg-white border-t border-gray-100 text-gray-400 py-10 text-center text-sm" data-id="element-15">
        <div className="max-w-4xl mx-auto px-4" data-id="element-16">
          <p className="mb-2" data-id="element-17">
            © 2024 Crianza Sin Celular. Todos los derechos reservados.
          </p>
          <p data-id="element-18">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>
    </div>;
}